export const enum ControlVariant {
    Horizontal = "horizontal",
    Vertical = "vertical",
    Count = "count",
    Create = "create" // never comes from backend
}
